// extracted by mini-css-extract-plugin
export default {"section":"MyJourney_section__TdXh-","inner":"MyJourney_inner__srKLA","timeline":"MyJourney_timeline__iZkT+"};